export const OBJECT = "object";
export const ACCIONES = "acciones";
export const CORREOS = "correos";
export const GEOCERCAS = "geocercas";
export const COLOR = "color";
export const COLOR_A_TIEMPO = "coloratiempo";
export const COLOR_RETRASO = "colorretraso";
export const UBICACION_GPS = "ubicaciongps";
export const CHECK = "check";
export const URL = "url";

export const STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3 = "accessTokenUltimaMillaV3";
export const STRING_ID_EMPRESA_ULTIMA_MILLA_V3 = "idEmpresaUltimaMillaV3";

export const STRING_SIDEBAR_EXPANDED_UMV3 = "SIDEBAR_EXPANDED_UM_V3";
export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const STRING_LANGUAGE_ULTIMA_MILLA = "language_ultima_milla_v3";

export const STRING_ID_ROL_USUARIO_WEB = "idRolUsuarioWeb";
export const STRING_ID_TIPO_USUARIO_WEB = "idTipoUsuarioWeb";
export const STRING_ID_USUARIO_WEB = "idUsuarioWeb";

export const STRING_SUPER_ADMIN = "b8e82c4f-5765-11f1-a30f-42010a8e000b";
